module.exports = __webpack_public_path__ + "img/vpn-6.dc3f0b85.jpg";